<template>
  <SvgBase width="34" height="34" viewBox="0 0 50 24" fill="none">
    <path d="M9.16003 11.96H41.47" :stroke="color" stroke-width="4" />
    <path
      d="M11.9599 16.6003C9.39995 16.6003 7.31995 14.5203 7.31995 11.9603C7.31995 9.4003 9.39995 7.32031 11.9599 7.32031C14.5199 7.32031 16.5999 9.4003 16.5999 11.9603C16.5999 14.5203 14.5199 16.6003 11.9599 16.6003Z"
      :fill="color"
    />
    <rect x="1" y="1" width="21.92" height="21.92" :stroke="color" stroke-width="3" />
    <path
      d="M33.1 11.9603C33.1 9.4003 35.18 7.32031 37.74 7.32031C40.3 7.32031 42.38 9.4003 42.38 11.9603C42.38 14.5203 40.3 16.6003 37.74 16.6003C35.18 16.6003 33.1 14.5203 33.1 11.9603Z"
      :fill="color"
      transform="translate(37.74, 11.9603) scale(0.892) translate(-37.74, -11.9603)"
    />
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconLinkDevice extends Vue {}
</script>
